import { useMemo as t } from "react";
import { useGisCategories as n } from "./index.es177.js";
function o(r) {
  const i = [];
  return r.forEach((e) => {
    if (e.type === "sub_category")
      e.is_visible && i.push(e);
    else if (Array.isArray(e.children)) {
      const s = o(e.children);
      s.length && i.push({
        ...e,
        children: s
      });
    }
  }), i;
}
const c = ({
  environment: r,
  token: i
}) => {
  const { categoriesData: e } = n({ environment: r, token: i });
  return t(() => o(e || []), [e]);
};
export {
  c as useCreatePoiCategories
};
//# sourceMappingURL=index.es388.js.map
